<template>
  <div style="color: #0b0b0b">
    <div class="importantTipsCont" style="margin-bottom: 10px;display: block;">
      <!--您确定要取消此 MDF-e 吗？-->
      <div class="cancelThisMDFe">{{ $t('mdfeTranslate.AreYouSureYouWantToCancelThisMDFe') }}</div>
      <!--此操作将使整张 MDF-e 作废，且无法恢复。-->
      <div>{{ $t('mdfeTranslate.ThisOperationWillCancelTheEntireMDFe') }}</div>
    </div>
    <div class="applicableScenarios">
      <div class="applicableScenariosCont">
        <i class="el-icon-time" />
      </div>
      <div class="applicableCont">
        <!--适用时间-->
        <div class="applicableTitle">{{ $t('mdfeTranslate.ApplicableTime') }}</div>
        <!--仅在 MDF-e 授权后24小时内且尚未启运时可取消。-->
        <div>
          {{ $t('mdfeTranslate.CanOnlyBeCancelled') }}
          <span style="color: #d52526;">{{ $t('mdfeTranslate.Within24Hours') }}</span>
          {{ $t('mdfeTranslate.Cancelable') }}
        </div>
      </div>
    </div>
    <el-divider style="margin: 10px 0" />
    <div class="applicableScenarios">
      <div class="iconfontCont">
        <i class="iconfont icon-a-ziyuan106" />
        <div class="iconfontError">
          <i class="el-icon-error" />
        </div>
      </div>
      <div class="applicableCont">
        <!--适用场景-->
        <div class="applicableTitle">{{ $t('mdfeTranslate.ApplicableScenarios') }}</div>
        <!--仅用于输入错误、重复等情况。-->
        <div>{{ $t('mdfeTranslate.OnlyUsedForInputErrorsOrDuplicateSituations') }}</div>
        <!--运输已开始则禁止取消。-->
        <div style="color: #d52526">{{ $t('mdfeTranslate.CannotBeCancelledOnceTheShipmentHasStarted') }}</div>
      </div>
    </div>
    <el-divider />
    <div class="operationResultCont">
      <div class="iconfontCont">
        <i class="el-icon-document" />
        <div class="iconfontError">
          <i class="el-icon-error" />
        </div>
      </div>
      <div class="applicableCont">
        <!--操作结果-->
        <div class="applicableTitle">{{ $t('mdfeTranslate.OperationResult') }}</div>
        <!--取消成功后，MDF-e 状态将变更为“已取消”。-->
        <div>
          <span>{{ $t('mdfeTranslate.AfterCancellation') }}</span>
          <span style="color: #d52526;">{{ $t('mdfeTranslate.Canceled') }}</span>
        </div>
      </div>
    </div>
    <div class="importantTipsCont" style="margin-bottom: 10px;">
      <div style="width: 60px">
        <i class="iconfont icon-a-zu665" />
      </div>
      <div class="applicableCont">
        <!--重要提示-->
        <div class="importantTips">{{ $t('mdfeTranslate.ImportantTips') }}</div>
        <!--取消后将无法恢复，请确认后谨慎操作。-->
        <div>{{ $t('mdfeTranslate.CancellationCannotBeRecovered') }}</div>
      </div>
    </div>
    <el-card class="box-card">
      <!--取消原因-->
      <div style="font-size: 16px;font-weight: bold;">
        {{ $t('mdfeTranslate.CancellationReason') }}
      </div>
      <!--为了便于后续管理，建议您填写取消原因。-->
      <div>{{ $t('mdfeTranslate.ToFacilitateSubsequentManagement') }}</div>
      <el-input
        v-model="cancelReason.cancellationReason" type="textarea" :rows="3"
        :placeholder="$t('GlobalSetObj.pleaseInput')"
      />
    </el-card>
  </div>
</template>
<script>
import { cancelMdfe } from '@/api/invoiceCenter';

export default {
  name: 'CancelMdfeTips',
  props: {
    rowMDFEData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      cancelReason: {
        cancellationReason: ''
      }
    };
  },
  methods: {
    confirmCancelMdfe() {
      const param = {
        mdfeKey: this.rowMDFEData.mdfeKey,
        cancellationReason: this.cancelReason.cancellationReason
      };
      cancelMdfe(param).then(res => {
        if (res.code === 200) {
          if (res.data.success) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // '操作成功'
            this.cancelReason.cancellationReason = '';
            this.$emit('cancelMdfeSuccess');
          } else {
            this.$message.error(res.data.failureReason || this.$t('mdfeTranslate.OperationFailed')); // 操作失败
          }
        }
      });
    }
  }
};
</script>
<style scoped>

</style>
